
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, CircularProgress, Avatar, Chip, Paper, Dialog, DialogContent, DialogActions, FormControl, TextField, InputLabel, IconButton, Box, Tabs, Tab, Checkbox } from '@mui/material';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';

import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { defaultCountries, parseCountry, PhoneInput } from 'react-international-phone';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from '../../components/Layout'

import { TabPanel, TabProps } from '../../helpers/TabPanel';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';

import { EnviarWhatsApp, GenerarCodigoAcceso, ObtenerGrupoAccesos, VisualizarAccesos } from '../../connections/comun/AccesoConnection';

import { defaultAcceso, PrivilegeGroup, VisualizarAccesoResponseProps } from '../../interfaces/comun/AccesoInterface';

import 'react-international-phone/style.css';
import '../../css/InputPhone.css';

const countries = defaultCountries.filter( ( country ) => {
    const { iso2 } = parseCountry( country );
    return ['mx', 'us'].includes(iso2);
});

export const RegistrosPage = () => {

    const dispatch = useDispatch();
    
    const navigate = useNavigate();

    const [loading, setLoading] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [loadingSend, setLoadingSend] = useState( false );

    const [openGenerarAcceso, setOpenGenerarAcceso] = useState( false );
    const [openVisualizarAcceso, setOpenVisualizarAcceso] = useState( false );
    
    const [nombres, setNombres] = useState( '' );
    const [apellidos, setApellidos] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    
    const [telefono, setTelefono] = useState( '' );
    const [existTelefono, setExistTelefono] = useState( false );

    const [acceso, setAcceso] = useState<VisualizarAccesoResponseProps>( defaultAcceso );

    const [rows, setRows] = useState<VisualizarAccesoResponseProps[]>( [] );
    const [recordsCount, setRecordsCount] = useState(0);
        
    const [value, setValue] = useState( 0 );

    const [fecha, setFecha] = useState ( moment( new Date() ) );
    const [duracion, setDuracion] = useState ( 60 );

    const [privilegeGroups, setPrivilegeGroups] = useState<PrivilegeGroup[]>( [] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );
    const { page: pagePrivilegeGroups, rowsPerPage: rowsPerPagePrivilegeGroups, handleChangePage: handleChangePagePrivilegeGroups, handleChangeRowsPerPage: handleChangeRowsPerPageGroups, resetPage: resetPagePrivilegeGroups } = usePages( 3 );

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue )

    const handleClear = () => {

        setNombres( '' );
        setApellidos( '' );
        setCorreoElectronico( '' );
        setTelefono( '' );

        resetPagePrivilegeGroups();

        setOpenGenerarAcceso( false );

    }

    const handleChangePrivilegeGroup =( privilegeGroupId: string, checked: boolean ) => {

        const newArray = privilegeGroups.map( (e) => {
            if( e.privilegeGroupId === privilegeGroupId ){
                e.selected = checked;
            }
            return e;
        });

        setPrivilegeGroups( newArray ); 

    }

    const handleGenerarAcceso = async () => {     

        if( telefono.length < 10 ){        
            dispatch( openSnackbar({ message: 'El número de teléfono no es validó', variant: 'warning' }));     
            return;          
        }
        else if( correoElectronico ){
            const validEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(correoElectronico);
            
            if( !validEmail ){   
                dispatch( openSnackbar({ message: 'El correo electrónico no tiene un formato validó', variant: 'warning' }));     
                return;
            }
        }

        setLoadingSave( true );

        await GenerarCodigoAcceso({ nombres, apellidos, correoElectronico, telefono, duracion, fecha: fecha.format( 'YYYY-MM-DDTHH:mm' ), privilegeGroups: privilegeGroups.filter( (e) => e.selected === true ).map( (e) => e.privilegeGroupId ) }).then( resp => {

            setTimeout(() => {
                
                const { success, message } = resp;

                if( success ){

                    setAcceso({ ...resp });

                    setRows([ resp, ...rows ]);

                    setExistTelefono( telefono !== '' );

                    handleClear();

                    setOpenVisualizarAcceso( true );
                    setLoadingSave( false );
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));     
                }
                else {

                    setLoadingSave( false );
                    dispatch( openSnackbar({ message: message, variant: 'error' }));     
                }

            }, 700);

        });

    }

    const handleEnviarWhatsApp = async () => {

        setLoadingSend( true );

        await EnviarWhatsApp({ idAcceso: acceso.idAcceso }).then( resp => {

            setTimeout(() => {
                
                const { success, message } = resp;
    
                if ( success ) {
                    dispatch( openSnackbar({ message: message, variant: 'success' }));                  
                }
                else {
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                }

                setLoadingSend( false );

            }, 700);


        });

    }

    useEffect(() => {
      
        async function obtener(){

            setLoading( true );
            setRows( [] );

            await VisualizarAccesos({ page, rowsPerPage }).then( resp => {

                setTimeout(() => {
                    
                    setRows( resp.records );
                    setRecordsCount( resp.recordsCount );
                    setLoading( false );

                }, 700);

            });

        }

        obtener();

    }, [ page, rowsPerPage ])   

    useEffect(() => {
          
        async function Obtener() {
            
            await ObtenerGrupoAccesos().then( resp => {

                const { success, privilegeGroups } = resp;

                if( success ){

                    const newArray = privilegeGroups.map( (e) => {                         
                        e.selected = false;
                        return e;  
                    });

                    setPrivilegeGroups(
                        [...newArray].sort(
                            (a, b) => parseInt( a.privilegeGroupId) - parseInt( b.privilegeGroupId )
                        )
                    );

                }

            });

        }

        if( openGenerarAcceso ){

            setExistTelefono( false );
            setPrivilegeGroups( [] );
            setDuracion( 60 );
            
            Obtener();
        }

    }, [ openGenerarAcceso ])    

    return (
        
        <Layout breadcrumbs={[ { text: 'Registro de accesos' } ]} backgroundPaper={ false }>

            <Grid container spacing={3} >  
                
                <Grid size={{ md: 6, xs: 12 }} textAlign={'start'}>

                    <Button color='secondary' startIcon={ <UndoIcon /> } sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>             
              
                <Grid size={{ md: 6, xs: 12 }} textAlign={'end'}>

                    <Button variant='contained' sx={{ mt: 1 }} onClick={ () => setOpenGenerarAcceso( true ) }> 
                        Agregar acceso
                    </Button> 

                </Grid>             

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Fecha </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Aplicación </TableCell>                          
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%', textAlign: 'center' }}> Imagen <br /> (Código Qr) </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%', textAlign: 'center' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            rows
                            .map( ( { idAcceso, fecha, aplicacion, referencia, imagen, idEstatus, estatus }, index ) => (

                                <TableRow key={ index } >
                                
                                    <TableCell sx={{ textAlign: 'center' }}>
                                        
                                        <Chip                                         
                                            label={ idAcceso }
                                            color={ idEstatus === 2 ? 'error': 'primary' }
                                        />

                                    </TableCell>

                                    <TableCell>

                                        {
                                            fecha
                                            &&
                                                <>
                                        
                                                    <Typography variant='subtitle1'>
                                                        { moment( fecha ).format( 'DD-MM-YYYY' ) }
                                                    </Typography>

                                                    <Typography variant='caption' color='text.secondary'>
                                                        { moment( fecha ).format( 'hh:mm a' ) }
                                                    </Typography>  
                                                
                                                </>
                                        }

                                    </TableCell>

                                    <TableCell>
                                        { aplicacion }
                                    </TableCell>     
                                                  
                                    <TableCell sx={{ justifyItems: 'center', textAlign: 'center' }}>   

                                        <Avatar 
                                            variant='rounded'
                                            sx={{ width: 135, height: 135 }}
                                            src={ imagen ? imagen : process.env.PUBLIC_URL + '/assets/sin-imagen.png' }
                                        />      

                                        <Typography variant='caption' color='secondary'>{ referencia }</Typography>
                                            
                                    </TableCell>
                                    
                                    <TableCell sx={{ textAlign: 'center' }}>

                                        <Chip color={ idEstatus === 2 ? 'error': 'primary' } label={ estatus } />

                                    </TableCell>    

                                </TableRow>

                            ))
                        }                    

                        { 
                            ( rows.length === 0 && !loading )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loading
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }
                        
                    </TableBody>

                    <TableFooter>

                        {
                            rows.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { recordsCount } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ recordsCount}                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>

                            }

                    </TableFooter>
                    
                </Table>

            </TableContainer>

            <Dialog 
                disableEscapeKeyDown 
                fullWidth
                maxWidth={ 'md' }
                open={ openGenerarAcceso }
                onClose={ () => {} }    
            >

                <DialogContent> 

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        
                        <Tabs value={ value } onChange={ handleChange } aria-label="basic tabs example" variant="scrollable" scrollButtons="auto">
                            <Tab label="Información de la persona" {...TabProps(0)} />
                            <Tab label="Configuración" {...TabProps(1)} />
                        </Tabs>

                    </Box>  

                    <TabPanel value={value} index={0}> 

                        <Grid container spacing={3} mt={3}>

                            <Grid size={{ md: 6, xs: 12 }}>

                                <FormControl fullWidth>  

                                    <TextField                                    
                                        label='Nombre(s)'                                
                                        placeholder="Juan"
                                        autoComplete="off"                             
                                        variant="outlined"                
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}               
                                        value={ nombres }
                                        onChange={ ( e ) => setNombres( e.target.value ) }            
                                    />

                                </FormControl>           

                            </Grid>
                    
                            <Grid size={{ md: 6, xs: 12 }}>

                                <FormControl fullWidth>  

                                    <TextField                                    
                                        label='Apellido(s)'                                
                                        placeholder="Peréz"
                                        autoComplete="off"                             
                                        variant="outlined"                
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}               
                                        value={ apellidos }
                                        onChange={ ( e ) => setApellidos( e.target.value ) }            
                                    />

                                </FormControl>           

                            </Grid>
                    
                            <Grid size={{ md: 12, xs: 12 }}>

                                <FormControl fullWidth>  

                                    <TextField                                    
                                        label='Correo electrónico'
                                        type="email"
                                        placeholder="persona@gmail.com"
                                        autoComplete="off"                             
                                        variant="outlined"                
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}               
                                        value={ correoElectronico }
                                        onChange={ ( e ) => setCorreoElectronico( e.target.value ) }            
                                    />

                                </FormControl>                           

                            </Grid>
                        
                            <Grid size={{ md: 12, xs: 12 }}>

                                <InputLabel sx={{ mb: 1 }}>Teléfono celular</InputLabel>                                               
                                <PhoneInput         
                                    defaultCountry="mx"                                
                                    countries={ countries }
                                    value={ telefono }
                                    onChange={ ( value ) => setTelefono( value ) }                                                    
                                />                                
                            </Grid>

                        </Grid>

                    </TabPanel>
                    
                    <TabPanel value={value} index={1}> 

                        <Grid container spacing={3} mt={3}>
                                
                            <Grid size={{ md: 4, xs: 12 }}>
                            
                                <FormControl fullWidth>  

                                    <TextField                                    
                                        label='Duración'   
                                        autoComplete="off"                             
                                        variant="outlined"                
                                        slotProps={{
                                            input: {
                                                autoComplete: 'off'
                                            },
                                            inputLabel: {
                                                shrink: true,
                                            }
                                        }}               
                                        value={ duracion }
                                        onChange={ ( e ) => setDuracion( e.target.value === '' ? 0 : parseInt( e.target.value ) ) }            
                                    />

                                </FormControl>           

                            </Grid>
                          
                            <Grid size={{ md: 8, xs: 12 }}>
                                        
                                <LocalizationProvider dateAdapter={ AdapterMoment }>

                                    <DateTimePicker 
                                        sx={{ width: '100%' }}
                                        label="Fecha"
                                        value={ fecha }
                                        minDate={ moment( new Date() ) }
                                        onChange={ (e) => setFecha( moment( e ) ) }
                                    />

                                </LocalizationProvider>                            

                            </Grid>
                     
                            <Grid size={{ md: 12, xs: 12 }}>

                                <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>
                                
                                    <Table sx={{ minWidth: 500 }}>
                    
                                        <TableHead sx={{ ...TableTheadStyle }}>
                    
                                            <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   
                    
                                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center'  }}> Id </TableCell>
                                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'80' }}> Descripción </TableCell>                                     
                                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>
                    
                                            </TableRow>
                    
                                        </TableHead>
                    
                                        <TableBody>
                    
                                            {
                                                (
                                                    rowsPerPage > 0
                                                    ? 
                                                        privilegeGroups.slice( pagePrivilegeGroups * rowsPerPagePrivilegeGroups, pagePrivilegeGroups * rowsPerPagePrivilegeGroups + rowsPerPagePrivilegeGroups )
                                                    : 
                                                        privilegeGroups
                                                )
                                                .map( ( { privilegeGroupId, privilegeGroupName, description, elementList, selected }, index ) => (
                    
                                                    <TableRow key={ index } >
                                                    
                                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'  }}>
                                                            { privilegeGroupId }
                                                        </TableCell>                                 
                    
                                                        <TableCell>
                                                            
                                                            <Typography variant='h6' fontSize={16}>                                                        
                                                                <strong>{ privilegeGroupName }</strong>
                                                            </Typography>

                                                            <Typography variant='subtitle1' fontSize={14}>{ description }</Typography>     

                                                            <Typography variant='caption'>
                                                                { 
                                                                    elementList.length !== 0 && `(${ elementList.map( (e) => e.element.baseInfo.areaName ).join(', ') })` 
                                                                }
                                                            </Typography>     

                                                        </TableCell>    

                                                        <TableCell sx={{ textAlign: 'end' }}>                                                   
                                                        
                                                            <Checkbox 
                                                                checked={ selected === true }
                                                                onChange={ (e) => handleChangePrivilegeGroup( privilegeGroupId, e.target.checked ) }
                                                            />
                    
                                                        </TableCell>
                    
                                                    </TableRow>
                    
                                                ))
                                            }                    
                                
                                            { 
                                                privilegeGroups.length === 0
                                                && 
                                                    <TableRow style={{ height: 73 }}>
                    
                                                        <TableCell colSpan={7} align="center"> 
                    
                                                            <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                            
                                                        </TableCell>
                    
                                                    </TableRow>                   
                                            }
                    
                                        </TableBody>
                    
                                        <TableFooter>
                    
                                            {
                                                privilegeGroups.length !== 0
                                                &&
                                                    <TableRow>           
                                                
                                                        <TablePagination  
                                                            sx={{ border: 'none'}}
                                                            rowsPerPageOptions={[]}
                                                            colSpan={8}
                                                            count={ privilegeGroups.length }                                        
                                                            rowsPerPage={ rowsPerPagePrivilegeGroups }
                                                            page={ pagePrivilegeGroups }          
                    
                                                            onPageChange={ handleChangePagePrivilegeGroups }
                                                            onRowsPerPageChange={ handleChangeRowsPerPageGroups }
                    
                                                            ActionsComponent={ TablePaginationActions }
                    
                                                            labelRowsPerPage=""                                            
                                                            labelDisplayedRows={
                                                                () => {
                                                                    return ''
                                                                }
                                                            }  
                                                        />
                    
                                                    </TableRow>
                                            }
                    
                                        </TableFooter>
                                        
                                    </Table>
                                    
                                </TableContainer>

                            </Grid>
                        
                        </Grid>                    

                    </TabPanel>

                </DialogContent>

                <DialogActions>
                    
                    <Button color='secondary' disabled={ loadingSave } onClick={ handleClear }>Cerrar</Button>
                    <Button variant='contained' disabled={ nombres === '' || apellidos === '' } loading={ loadingSave } onClick={ handleGenerarAcceso }>Generar</Button>

                </DialogActions>

            </Dialog>    

            <Dialog
                disableEscapeKeyDown
                open={ openVisualizarAcceso }
                onClose={ () => {} }
                maxWidth={ 'md' }
            >
                <IconButton                        
                    onClick={ () => { setOpenVisualizarAcceso( false ); setAcceso( defaultAcceso ); } }
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent sx={{ width: 320 }}>

                    <Box>

                        <Box textAlign={'center'} mt={3}>

                            {
                                acceso.imagen
                                &&
                                    <img
                                        alt='imagen-qr'
                                        src={ acceso.imagen }
                                        style={{ width: 220, height: 220 }}
                                    />
                            }

                        </Box>         

                    </Box>

                    {
                        existTelefono
                        &&
                            <Button
                                fullWidth
                                color='success'
                                variant='contained'
                                onClick={ handleEnviarWhatsApp }
                                loading={ loadingSend }                              
                                sx={{ mt: 3 }}
                                startIcon={
                                    <WhatsAppIcon
                                        sx={{
                                            fontSize: 18,
                                            "&.MuiSvgIcon-root": {
                                                fontSize: 18,
                                            },
                                        }}
                                    />
                                }
                            >
                               Enviar por WhatsAppp
                            </Button>
                    }

                </DialogContent>

            </Dialog>            

        </Layout>
        
    )
}
